import { render, staticRenderFns } from "./plmDocDistribution.vue?vue&type=template&id=58854932&scoped=true"
import script from "./plmDocDistribution.vue?vue&type=script&lang=js"
export * from "./plmDocDistribution.vue?vue&type=script&lang=js"
import style0 from "./plmDocDistribution.vue?vue&type=style&index=0&id=58854932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58854932",
  null
  
)

export default component.exports